function cubicInOut(t) {
  return t < 0.5
    ? 4.0 * t * t * t
    : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0
}

module.exports = cubicInOut


//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/cubic-in-out.js
// module id = 26
// module chunks = 0